import { Clonable } from '../../..';

export class TeamTrial extends Clonable {
  constructor(
    public readonly startedAt: Date,
    public readonly endsAt: Date,
    public readonly duration: number,
    public readonly seats: number,
  ) {
    super();
  }

  public getRemainingDays(): number {
    const now = new Date();

    if (now >= this.endsAt) {
      return 0;
    }

    const diffTime = this.endsAt.getTime() - now.getTime();
    const remaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return Math.min(remaining, this.duration);
  }

  public isExpired(): boolean {
    return !this.isActive();
  }

  public isActive(): boolean {
    return new Date() < this.endsAt;
  }
}
